import type { FaireProductEntity } from "../../entity_types/product";

export const viverano_5: FaireProductEntity = {
  token: "viverano-5",
  type: "product",
  name: "Horse Dreams - Organic Cotton Jacquard Knit Baby Blanket",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/9c76dbc989e299eb50f3bdd61e7fc49a67b2b453b2625e22e90748c3f90aff2c.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 38.5,
  msrpDollars: 68,
  freeShipping: true,
  isBestseller: true,
  description: "",
  categoryTokens: ["cat_proto_nursery-decor"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
